import { render } from "./_CvEmpty.vue?vue&type=template&id=fbd9ad76"
const script = {}

import exportComponent from "/home/runner/work/carbon-components-vue/carbon-components-vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__